import React, {PropsWithChildren} from "react";
import Overlay from "../Overlay";
import {CloseRoundIcon} from "assets/icon";
import {DrawerProps} from "../../types";
import ArrowLeftIcon from "../../assets/icon/ArrowLeftIcon";

export default function Drawer({
                                   children,
                                   showClose = true,
                                   onClose,
                                   isOpen = false,
                                   title,
                                   zIndex = 100,
                                    onBack
                               }: DrawerProps) {

    if (!isOpen) {
        return <></>
    }


    return <Overlay isOpen={isOpen} zIndex={zIndex}>
        <div className={"matchid-drawer"}>
            <div className={`matchid-drawer-header matchid-flex`}>
                <div className={`matchid-drawer-header-content matchid-flex`}>
                    {onBack && <ArrowLeftIcon height={25} width={24} className="matchid-drawer-header-back" onClick={onBack}/>}
                    {title}
                </div>
                {
                    showClose && <CloseRoundIcon className={"matchid-drawer-header-close"} onClick={onClose}/>
                }
            </div>

            {children}
        </div>
    </Overlay>
}